import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {getAssetPath} from '../../../src/utils/DieselUtils';
import cx from 'classnames';
import styles from './RatingOverlay.pcss';
import {video} from '../../constants';

export class RatingOverlay extends PureComponent {
    static propTypes = {
        rating: PropTypes.array,
        epicStillType: PropTypes.string,
        visible: PropTypes.bool
    };

    render() {
        const {epicStillType, rating, visible} = this.props;
        const {wrapperClassName, imgClassName, imgWrapperClassName} = classSelector(epicStillType);

        const superWrapperClassName = cx(
            wrapperClassName,
            {[styles.hidden]: !visible},
            {[styles.transition]: !visible}
        );

        return (
            <span className={superWrapperClassName}>
                <span className={imgWrapperClassName}>
                    {rating.map(img => (
                        <img
                            className={cx(imgClassName)}
                            key={img.src}
                            src={getAssetPath(img.src)}
                            alt={img.altText}
                        />
                    ))}
                </span>
            </span>
        );
    }
}

function classSelector(epicStillType) {
    const res = {};
    if (
        epicStillType === video.epicStillTypes.PREPEND ||
        epicStillType === video.epicStillTypes.APPEND
    ) {
        res.wrapperClassName = styles.full;
        res.imgClassName = styles.image_centered;
        res.imgWrapperClassName = styles.image;
    } else {
        let cn;
        switch (epicStillType) {
            case video.epicStillTypes.OVERLAY_TL:
                cn = styles.topLeft;
                break;
            case video.epicStillTypes.OVERLAY_TR:
                cn = styles.topRight;
                break;
            case video.epicStillTypes.OVERLAY_BL:
                cn = styles.bottomLeft;
                break;
            case video.epicStillTypes.OVERLAY_BR:
                cn = styles.bottomRight;
                break;
            default:
                cn = styles.topLeft;
        }
        res.wrapperClassName = cx(styles.overlay, cn);
        res.imgClassName = styles.image_overlay;
        res.imgWrapperClassName = styles.image_overlay;
    }
    return res;
}

export default RatingOverlay;
